import {types} from './types';

const initialState = {
    list: [],
    history: {
        data: [],
        countPage: 0
    }
}

export function personalReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_PERSONAL_BONUSES:
            return { ...state, list: action.payload};
        case types.SET_HISTORY_BONUSES:
            return { ...state, history: action.payload};
        default:
            return state
    }
}